import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchDoctorsData } from '../../features/Doctors/Doctor';
import CardDoctor from './CardDoctor';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import { Autoplay } from "swiper/modules";
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowRight, { ArrowLeft } from '../../Icons/Icon';
import { SeeMore } from '../../Buttons/Buttons';
import Tabs from '../Tabs/Tabs';
import getDirctionLang from '../../Actions/getDirctionLang';

function DoctorPage() {
    const dispatch = useDispatch();
    const { doctors, teams } = useSelector((state) => state.doctors);
    const { i18n, t } = useTranslation();
    useEffect(() => {
        dispatch(fetchDoctorsData({ perPage: 8, countryId: "all" }));
    }, [dispatch, i18n.language]);
    const isRtl = getDirctionLang();
    const [mergedData, setMergedData] = useState([]);

    useEffect(() => {
        if (!doctors && !teams) return;

        // tag each item so you still know where it came from
        const tempTeams = (teams || []).map(team => ({
            ...team,
            type: "team"
        }));
        const tempDoctors = (doctors || []).map(doc => ({
            ...doc,
            type: "doctor"
        }));

        // merge and sort by surgery descending
        const merged = [...tempDoctors, ...tempTeams].sort((a, b) => {
            // if surgery is ever a string, coerce to number:
            const surgA = Number(a.surgery) || 0;
            const surgB = Number(b.surgery) || 0;
            return surgB - surgA;
        });

        setMergedData(merged);
    }, [doctors, teams]);

    return (
        <div className='mx-auto w-full lg:w-10/12 xl:w-10/12 2xl:w-9/12 md:p-10 my-3 mt-5'>
            <div className="flex flex-col gap-4">
                <p className="font-bold text-center text-4xl">{t("ourTeam")}</p>
            </div>


            {mergedData?.length > 0 && (
                <Swiper
                    key={i18n.language}
                    modules={[Autoplay]}
                    slidesPerView={1}
                    breakpoints={{
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                        1280: { slidesPerView: 3 },
                    }}
                    dir={isRtl ? "rtl" : "ltr"}
                    navigation={{
                        nextEl: isRtl ? ".prev" : ".next",
                        prevEl: isRtl ? ".next" : ".prev",
                        clickable: true,
                    }}

                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                        waitForTransition: true
                    }}
                    loop={true}
                    spaceBetween={20}
                    observer={true}
                    observeParents={true}
                    className="mySwiper mt-6"
                >
                    {mergedData.map((doctor, index) => (
                        <SwiperSlide key={index}>
                            <Link to={`/doctors/${doctor.id}/${doctor.type}`}>
                                <div className="flex   justify-center gap-6">
                                    <CardDoctor width={"w-11/12"} doctor={doctor} t={t} i18n={i18n} />
                                </div>
                            </Link>
                        </SwiperSlide>
                    ))}
                    <ArrowRight></ArrowRight>
                    <ArrowLeft />
                </Swiper>
            )}
            <div className="flex justify-center mt-4">

                <SeeMore link={"/doctor"} />
            </div>
        </div>
    );
}

export default DoctorPage;
